import React from 'react'
import './Choose.css';

function Choose() {
  return (
    <div className='choose'>
       <div className='choose-header'>
         <h2>Healthy Living Starts Here</h2>
         <p>Discover the benefits of choosing us</p>
       </div>

       <div className='choose-con'>
          <div className='choose-card'>
           <div className='ben-icon'>
              <img src="https://res.cloudinary.com/dxnukbo0u/image/upload/v1712613103/icons8-innovation-50_oeplhj.png" alt="" />
             </div>
            <p>Comprehensive Healthcare Services</p>
            <span>We offer a full range of healthcare services to meet all your medical needs, from routine check-ups to specialized treatments.</span>
         </div>

          <div className='choose-card'>
            <div className='ben-icon'>
              <img src="https://res.cloudinary.com/dxnukbo0u/image/upload/v1706321775/icons8-jet-85_q3ekaa.png" alt="" />
             </div>
            <p>Advanced Diagnostic Facilities</p>
            <span>Our state-of-the-art diagnostic centre uses the latest technology for accurate and timely results. We offer a range of services, including imaging and lab tests.</span>
         </div>

          <div className='choose-card'>
            <div className='ben-icon'>
              <img src="https://res.cloudinary.com/dxnukbo0u/image/upload/v1706319001/icons8-team-50_i0hmdx.png" alt="" />
             </div>
            <p>Expert Medical Team</p>
            <span>Our experienced and compassionate team provides personalized care, creating tailored treatment plans for your needs.</span>
         </div>
         
       </div>
    </div>
  )
}

export default Choose